<template>
  <div class="svg-container">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1900 850"
      style="enable-background: new 0 0 1900 850"
      xml:space="preserve"
    >
      <circle
        id="Heart_pink_2"
        class="heartbeat st0"
        cx="482.1"
        cy="287.9"
        r="18"
      />
      <circle
        id="heart_green_1"
        class="heartbeat st1"
        cx="629.5"
        cy="326.7"
        r="15.5"
      />
      <circle
        id="Heart_pink_1"
        class="heartbeat st2"
        cx="333.6"
        cy="290.8"
        r="15.5"
      />
      <circle
        id="Heart_blue"
        class="heartbeat st3"
        cx="852.8"
        cy="351.9"
        r="18"
      />
      <circle
        id="Heart_pink_3"
        class="heartbeat st0"
        cx="995.3"
        cy="357.6"
        r="13.6"
      />
      <circle
        id="Heart_yellow"
        class="heartbeat st4"
        cx="1621.1"
        cy="344.7"
        r="13.6"
      />
      <circle
        id="Heart_pink_5"
        class="heartbeat st0"
        cx="1471.1"
        cy="345.5"
        r="15.2"
      />
      <circle
        id="Heart_pink_4"
        class="heartbeat st0"
        cx="1318.9"
        cy="340.3"
        r="12.8"
      />
      <g id="people">
        <circle class="st5" cx="1286.7" cy="134.4" r="6.5" />
        <circle class="st5" cx="1286.7" cy="109" r="6.5" />
        <circle class="st5" cx="1286.7" cy="83.7" r="6.5" />
        <circle class="st5" cx="1286.7" cy="55.9" r="6.5" />
        <circle class="st5" cx="1286.7" cy="30.5" r="6.5" />
        <circle class="st5" cx="1106.9" cy="252.9" r="8.9" />
        <circle class="st5" cx="1106.4" cy="228.2" r="8.9" />
        <circle class="st5" cx="1165.5" cy="557.9" r="8.9" />
        <circle class="st5" cx="1166.2" cy="612.9" r="8.9" />
        <circle class="st5" cx="1166.2" cy="640.2" r="8.9" />
        <circle class="st5" cx="1165.7" cy="586.2" r="8.9" />
        <circle class="st5" cx="1198.2" cy="547.1" r="8.9" />
        <circle class="st5" cx="1198.9" cy="611.6" r="8.9" />
        <circle class="st5" cx="1198.4" cy="583.5" r="8.9" />
        <circle class="st5" cx="1105" cy="559" r="8.9" />
        <circle class="st5" cx="1105.7" cy="614" r="8.9" />
        <circle class="st5" cx="1105.7" cy="641.3" r="8.9" />
        <circle class="st5" cx="1105.2" cy="587.3" r="8.9" />
        <path
          class="st6"
          d="M1011.4,78.3c-28,0-50.7,22.7-50.7,50.7c0,28,22.7,50.7,50.7,50.7c28,0,50.7-22.7,50.7-50.7
		C1062.1,101,1039.4,78.3,1011.4,78.3z M1011.4,164.7c-19.8,0-35.8-16-35.8-35.8s16-35.8,35.8-35.8s35.8,16,35.8,35.8
		S1031.2,164.7,1011.4,164.7z"
        />
        <circle class="st7" cx="817" cy="493.2" r="18" />
        <circle class="st7" cx="817" cy="527.6" r="18" />
        <circle class="st7" cx="817" cy="559.3" r="18" />
        <circle class="st7" cx="817" cy="592.7" r="18" />
        <circle class="st7" cx="817" cy="626.9" r="18" />
        <circle class="st7" cx="817" cy="661.2" r="18" />
        <circle class="st7" cx="817" cy="727.4" r="18" />
        <circle class="st7" cx="817" cy="460.5" r="18" />
        <circle class="st7" cx="853.6" cy="460.5" r="18" />
        <circle class="st7" cx="853.6" cy="494.2" r="18" />
        <circle class="st7" cx="853.6" cy="531" r="18" />
        <circle class="st3" cx="853.6" cy="565.4" r="18" />
        <circle class="st3" cx="894.6" cy="528.8" r="13.7" />
        <circle class="st3" cx="781.2" cy="528.8" r="13.7" />
        <circle class="st3" cx="853.6" cy="424.1" r="18" />
        <circle class="st3" cx="816.7" cy="424.1" r="18" />
        <circle class="st3" cx="816.7" cy="387.8" r="18" />
        <circle class="st3" cx="816.7" cy="351.9" r="18" />
        <circle class="st1" cx="629.1" cy="363" r="18" />
        <circle class="st8" cx="629.1" cy="581" r="18" />
        <circle class="st0" cx="445.1" cy="543.3" r="18" />
        <circle class="st0" cx="446.1" cy="580.1" r="18" />
        <circle class="st0" cx="445.4" cy="617.7" r="18" />
        <circle class="st0" cx="444.5" cy="655.1" r="18" />
        <circle class="st0" cx="406.4" cy="733.1" r="18" />
        <circle class="st0" cx="332.3" cy="731.6" r="18" />
        <circle class="st0" cx="482.1" cy="252.9" r="18" />
        <circle class="st0" cx="334.5" cy="399" r="18" />
        <circle class="st0" cx="297.5" cy="399.6" r="18" />
        <circle class="st0" cx="334.5" cy="362.2" r="18" />
        <circle class="st0" cx="297.5" cy="362.9" r="18" />
        <circle class="st0" cx="519.8" cy="251.8" r="18" />
        <circle class="st0" cx="482.4" cy="508.3" r="18" />
        <circle class="st0" cx="518" cy="509" r="18" />
        <circle class="st8" cx="555" cy="549.2" r="18" />
        <circle class="st5" cx="555" cy="509.1" r="18" />
        <circle class="st8" cx="555.6" cy="583.9" r="18" />
        <circle class="st8" cx="555.6" cy="619.8" r="18" />
        <circle class="st0" cx="444.5" cy="252.9" r="18" />
        <circle class="st8" cx="592.1" cy="720.7" r="18" />
        <circle class="st8" cx="627.8" cy="754.6" r="18" />
        <circle class="st8" cx="664.3" cy="754.8" r="18" />
        <circle class="st1" cx="701.3" cy="328.5" r="18" />
        <circle class="st8" cx="701.3" cy="653.9" r="18" />
        <circle class="st8" cx="556.5" cy="653.9" r="18" />
        <circle class="st0" cx="521.2" cy="652.6" r="14.4" />
        <circle class="st1" cx="701.3" cy="291.3" r="18" />
        <circle class="st1" cx="666.6" cy="290.7" r="18" />
        <circle class="st1" cx="594.1" cy="252.7" r="18" />
        <circle class="st1" cx="594.5" cy="216.2" r="18" />
        <circle class="st1" cx="629.5" cy="291" r="15.5" />
        <circle class="st1" cx="593.9" cy="290.7" r="15.5" />
        <circle class="st8" cx="556.1" cy="290.7" r="15.5" />
        <circle class="st2" cx="481.6" cy="215.6" r="15.5" />
        <circle class="st2" cx="482.7" cy="178.2" r="15.5" />
        <circle class="st2" cx="486.1" cy="577.2" r="15.5" />
        <circle class="st2" cx="441.5" cy="733.5" r="15.5" />
        <circle class="st2" cx="299.7" cy="616.6" r="15.5" />
        <circle class="st2" cx="259.5" cy="511" r="15.5" />
        <circle class="st2" cx="259.7" cy="365.1" r="15.5" />
        <circle class="st2" cx="260.1" cy="327.6" r="15.5" />
        <circle class="st2" cx="295.6" cy="324.9" r="15.5" />
        <circle class="st2" cx="333.6" cy="324.9" r="15.5" />
        <circle class="st2" cx="295.6" cy="290.8" r="15.5" />
        <circle class="st0" cx="295.6" cy="252.7" r="15.5" />
        <circle class="st0" cx="260.6" cy="290.6" r="15.5" />
        <circle class="st0" cx="334.4" cy="183.9" r="15.5" />
        <circle class="st0" cx="298.2" cy="183" r="15.5" />
        <circle class="st0" cx="334.4" cy="216.7" r="15.5" />
        <circle class="st0" cx="298.2" cy="215.8" r="15.5" />
        <circle class="st2" cx="333.6" cy="252.7" r="15.5" />
        <circle class="st2" cx="483.9" cy="544.3" r="15.5" />
        <circle class="st3" cx="852.8" cy="386.9" r="18" />
        <circle class="st3" cx="928.8" cy="425.5" r="18" />
        <circle class="st3" cx="928" cy="388.3" r="18" />
        <circle class="st3" cx="816.7" cy="316.6" r="18" />
        <circle class="st3" cx="928.8" cy="458.8" r="16.2" />
        <circle class="st9" cx="852.6" cy="316.6" r="18" />
        <circle class="st9" cx="781.5" cy="313.9" r="18" />
        <circle class="st8" cx="593" cy="361.2" r="18" />
        <circle class="st3" cx="853.6" cy="599.7" r="18" />
        <circle class="st3" cx="853.6" cy="633.6" r="16.2" />
        <circle class="st3" cx="816.4" cy="694.7" r="14.6" />
        <circle class="st3" cx="816.4" cy="760.4" r="14.6" />
        <circle class="st3" cx="849.7" cy="726.9" r="14.6" />
        <circle class="st3" cx="878.6" cy="726.9" r="14.6" />
        <circle class="st3" cx="878.6" cy="696.6" r="14.6" />
        <circle class="st3" cx="784.9" cy="726.9" r="14.6" />
        <circle class="st9" cx="853.4" cy="668.3" r="10.9" />
        <circle class="st7" cx="890.6" cy="425.9" r="18" />
        <circle class="st7" cx="890.6" cy="461.4" r="18" />
        <circle class="st7" cx="890.6" cy="494.2" r="18" />
        <circle class="st7" cx="890.6" cy="389.3" r="18" />
        <circle class="st7" cx="890.6" cy="352.7" r="18" />
        <circle class="st7" cx="890.6" cy="316.2" r="18" />
        <circle class="st7" cx="856.8" cy="276.5" r="14.8" />
        <circle class="st7" cx="856.8" cy="244.2" r="10.8" />
        <circle class="st1" cx="667.1" cy="253.7" r="10.8" />
        <circle class="st1" cx="630.5" cy="253.7" r="10.8" />
        <circle class="st8" cx="558.8" cy="754.2" r="10.8" />
        <circle class="st8" cx="559.1" cy="723.2" r="10.8" />
        <circle class="st8" cx="667.1" cy="224.1" r="10.8" />
        <circle class="st8" cx="630.5" cy="224.1" r="10.8" />
        <circle class="st7" cx="818.1" cy="244.2" r="10.8" />
        <circle class="st9" cx="818.1" cy="219.9" r="10.8" />
        <circle class="st2" cx="259.4" cy="251" r="10.8" />
        <circle class="st2" cx="297" cy="148.9" r="10.8" />
        <circle class="st2" cx="258.9" cy="541.4" r="10.8" />
        <circle class="st8" cx="593.5" cy="325.5" r="10.8" />
        <circle class="st10" cx="630.2" cy="622.5" r="12.3" />
        <circle class="st10" cx="631" cy="654.5" r="12.3" />
        <circle class="st10" cx="734.3" cy="655" r="12.3" />
        <circle class="st10" cx="695.2" cy="756" r="12.3" />
        <circle class="st9" cx="929.3" cy="485.6" r="10.8" />
        <circle class="st9" cx="929.3" cy="357.7" r="10.8" />
        <circle class="st9" cx="745.5" cy="453.7" r="10.8" />
        <circle class="st9" cx="746" cy="480.7" r="10.8" />
        <circle class="st9" cx="745.1" cy="427.1" r="10.8" />
        <circle class="st7" cx="817.9" cy="276.5" r="14.8" />
        <circle class="st7" cx="781.9" cy="460.2" r="18" />
        <circle class="st7" cx="781.9" cy="495.7" r="18" />
        <circle class="st7" cx="781.9" cy="423.6" r="18" />
        <circle class="st7" cx="781.9" cy="387" r="18" />
        <circle class="st7" cx="781.9" cy="350.5" r="18" />
        <circle class="st11" cx="592.5" cy="507.3" r="18" />
        <circle class="st11" cx="592.5" cy="542.8" r="18" />
        <circle class="st11" cx="592.5" cy="470.7" r="18" />
        <circle class="st11" cx="592.5" cy="434.1" r="18" />
        <circle class="st11" cx="592.5" cy="652.2" r="18" />
        <circle class="st11" cx="592.5" cy="687.7" r="18" />
        <circle class="st11" cx="592.5" cy="753.8" r="18" />
        <circle class="st11" cx="592.5" cy="615.6" r="18" />
        <circle class="st11" cx="592.5" cy="579" r="18" />
        <circle class="st11" cx="664.4" cy="652.2" r="18" />
        <circle class="st11" cx="664.4" cy="615.6" r="18" />
        <circle class="st11" cx="664.4" cy="579" r="18" />
        <circle class="st11" cx="592.5" cy="397.6" r="18" />
        <circle class="st12" cx="556" cy="470.7" r="18" />
        <circle class="st11" cx="556" cy="434.1" r="18" />
        <circle class="st11" cx="556" cy="397.6" r="18" />
        <circle class="st12" cx="518.4" cy="470.7" r="18" />
        <circle class="st12" cx="518.4" cy="434.1" r="18" />
        <circle class="st12" cx="518.4" cy="397.6" r="18" />
        <circle class="st12" cx="482.3" cy="470.7" r="18" />
        <circle class="st12" cx="484.8" cy="656.1" r="22.6" />
        <circle class="st12" cx="485.6" cy="613.4" r="20.1" />
        <circle class="st12" cx="482.3" cy="434.1" r="18" />
        <circle class="st12" cx="482.3" cy="397.6" r="18" />
        <circle class="st12" cx="482.3" cy="361.1" r="18" />
        <circle class="st12" cx="482.3" cy="324.6" r="18" />
        <circle class="st12" cx="445.8" cy="470.7" r="18" />
        <circle class="st12" cx="445.8" cy="506.5" r="18" />
        <circle class="st0" cx="369.6" cy="546.7" r="18" />
        <circle class="st0" cx="370.6" cy="583.5" r="18" />
        <circle class="st0" cx="369.9" cy="621" r="18" />
        <circle class="st0" cx="298.3" cy="581.4" r="18" />
        <circle class="st2" cx="261.5" cy="590.8" r="15.5" />
        <circle class="st0" cx="262.9" cy="626" r="18" />
        <circle class="st0" cx="370.6" cy="657" r="18" />
        <circle class="st0" cx="369.9" cy="694.6" r="18" />
        <circle class="st12" cx="370.3" cy="509.9" r="18" />
        <circle class="st12" cx="445.8" cy="434.1" r="18" />
        <circle class="st12" cx="445.8" cy="397.6" r="18" />
        <circle class="st12" cx="518.8" cy="361.2" r="18" />
        <circle class="st12" cx="518.8" cy="324.6" r="18" />
        <circle class="st11" cx="555.3" cy="362.3" r="18" />
        <circle class="st11" cx="555.3" cy="325.7" r="18" />
        <circle class="st12" cx="518.8" cy="288.1" r="18" />
        <circle class="st12" cx="444.6" cy="361.2" r="18" />
        <circle class="st12" cx="444.6" cy="324.6" r="18" />
        <circle class="st12" cx="444.6" cy="288.1" r="18" />
        <circle class="st12" cx="409.2" cy="361.2" r="18" />
        <circle class="st12" cx="409.2" cy="324.6" r="18" />
        <circle class="st12" cx="409.2" cy="288.1" r="18" />
        <circle class="st12" cx="374.1" cy="361.2" r="18" />
        <circle class="st12" cx="374.1" cy="396.8" r="18" />
        <circle class="st12" cx="374.1" cy="324.6" r="18" />
        <circle class="st12" cx="374.1" cy="288.1" r="18" />
        <circle class="st12" cx="297.9" cy="509.6" r="18" />
        <circle class="st12" cx="297.9" cy="545.2" r="18" />
        <circle class="st12" cx="297.9" cy="473" r="18" />
        <circle class="st12" cx="297.9" cy="436.5" r="18" />
        <circle class="st12" cx="261.1" cy="474.2" r="18" />
        <circle class="st12" cx="261.1" cy="437.5" r="18" />
        <circle class="st12" cx="261.1" cy="401.1" r="18" />
        <circle class="st12" cx="263.8" cy="736.8" r="18" />
        <circle class="st12" cx="369" cy="732.5" r="18" />
        <circle class="st12" cx="263.8" cy="772.3" r="18" />
        <circle class="st12" cx="263.8" cy="700.2" r="18" />
        <circle class="st12" cx="263.8" cy="663.7" r="18" />
        <circle class="st12" cx="333.4" cy="509.6" r="18" />
        <circle class="st12" cx="333.4" cy="473" r="18" />
        <circle class="st12" cx="333.4" cy="436.5" r="18" />
        <circle class="st12" cx="374.1" cy="251.9" r="18" />
        <circle class="st11" cx="629" cy="507.8" r="18" />
        <circle class="st11" cx="629" cy="543.2" r="18" />
        <circle class="st11" cx="629" cy="471.1" r="18" />
        <circle class="st11" cx="629" cy="434.5" r="18" />
        <circle class="st1" cx="629" cy="398" r="18" />
        <circle class="st11" cx="664.4" cy="507.8" r="18" />
        <circle class="st11" cx="664.4" cy="543.2" r="18" />
        <circle class="st11" cx="664.4" cy="471.1" r="18" />
        <circle class="st11" cx="664.4" cy="434.5" r="18" />
        <circle class="st11" cx="664.4" cy="398" r="18" />
        <circle class="st11" cx="664.4" cy="363.8" r="18" />
        <circle class="st11" cx="664.4" cy="327.3" r="18" />
        <circle class="st11" cx="699.7" cy="434.5" r="18" />
        <circle class="st11" cx="699.7" cy="400.3" r="18" />
        <circle class="st11" cx="699.7" cy="363.8" r="18" />
        <circle class="st5" cx="892" cy="285.1" r="8.9" />
        <circle class="st5" cx="891.5" cy="258.4" r="8.9" />
        <circle class="st5" cx="891" cy="230.9" r="8.9" />
        <circle class="st5" cx="929.9" cy="332.2" r="8.9" />
        <circle class="st5" cx="929.4" cy="305.5" r="8.9" />
        <circle class="st5" cx="928.9" cy="278" r="8.9" />
        <circle class="st5" cx="929.9" cy="252.3" r="8.9" />
        <circle class="st5" cx="929.4" cy="225.6" r="8.9" />
        <circle class="st5" cx="928.9" cy="198.2" r="8.9" />
        <circle class="st5" cx="857.2" cy="217.5" r="8.9" />
        <circle class="st5" cx="856.7" cy="190.8" r="8.9" />
        <circle class="st5" cx="856.2" cy="163.4" r="8.9" />
        <circle class="st5" cx="818.3" cy="194" r="8.9" />
        <circle class="st5" cx="817.8" cy="167.3" r="8.9" />
        <circle class="st5" cx="817.3" cy="139.8" r="8.9" />
        <circle class="st5" cx="556.7" cy="257.2" r="8.9" />
        <circle class="st5" cx="556.1" cy="230.5" r="8.9" />
        <circle class="st5" cx="555.7" cy="203.1" r="8.9" />
        <circle class="st5" cx="556.7" cy="176" r="8.9" />
        <circle class="st5" cx="556.1" cy="149.3" r="8.9" />
        <circle class="st5" cx="555.7" cy="121.9" r="8.9" />
        <circle class="st5" cx="521.6" cy="217.9" r="8.9" />
        <circle class="st5" cx="521.1" cy="191.2" r="8.9" />
        <circle class="st5" cx="520.6" cy="163.8" r="8.9" />
        <circle class="st5" cx="892" cy="205.2" r="8.9" />
        <circle class="st5" cx="891.5" cy="178.5" r="8.9" />
        <circle class="st5" cx="891" cy="151.1" r="8.9" />
        <circle class="st5" cx="409.8" cy="254.3" r="8.9" />
        <circle class="st5" cx="409.3" cy="226.9" r="8.9" />
        <circle class="st5" cx="410.3" cy="201.2" r="8.9" />
        <circle class="st5" cx="409.8" cy="174.5" r="8.9" />
        <circle class="st5" cx="409.3" cy="147" r="8.9" />
        <circle class="st5" cx="375.7" cy="216.8" r="8.9" />
        <circle class="st5" cx="375.2" cy="189.4" r="8.9" />
        <circle class="st5" cx="376.2" cy="163.7" r="8.9" />
        <circle class="st5" cx="375.7" cy="137" r="8.9" />
        <circle class="st5" cx="335.3" cy="153.4" r="8.9" />
        <circle class="st5" cx="334.7" cy="126.7" r="8.9" />
        <circle class="st5" cx="297.7" cy="123.9" r="8.9" />
        <circle class="st5" cx="297.2" cy="97.2" r="8.9" />
        <circle class="st5" cx="259.1" cy="222.8" r="8.9" />
        <circle class="st5" cx="258.6" cy="196.1" r="8.9" />
        <circle class="st5" cx="259.1" cy="170.5" r="8.9" />
        <circle class="st5" cx="258.6" cy="143.8" r="8.9" />
        <circle class="st5" cx="332.5" cy="596.2" r="8.9" />
        <circle class="st5" cx="333" cy="570.6" r="8.9" />
        <circle class="st5" cx="332.5" cy="543.9" r="8.9" />
        <circle class="st5" cx="332.5" cy="676.9" r="8.9" />
        <circle class="st5" cx="333" cy="651.3" r="8.9" />
        <circle class="st5" cx="332.5" cy="624.6" r="8.9" />
        <circle class="st5" cx="300.6" cy="701.9" r="8.9" />
        <circle class="st5" cx="301.1" cy="676.3" r="8.9" />
        <circle class="st5" cx="300.6" cy="649.7" r="8.9" />
        <circle class="st5" cx="530.3" cy="777" r="8.9" />
        <circle class="st5" cx="530.8" cy="751.4" r="8.9" />
        <circle class="st5" cx="530.3" cy="724.7" r="8.9" />
        <circle class="st5" cx="521.2" cy="619" r="8.9" />
        <circle class="st5" cx="521.7" cy="593.4" r="8.9" />
        <circle class="st5" cx="521.2" cy="566.7" r="8.9" />
        <circle class="st5" cx="521.2" cy="542.8" r="8.9" />
        <circle class="st5" cx="375.2" cy="109.5" r="8.9" />
        <circle class="st5" cx="409.8" cy="503.3" r="8.9" />
        <circle class="st5" cx="409.3" cy="475.8" r="8.9" />
        <circle class="st5" cx="410.3" cy="450.1" r="8.9" />
        <circle class="st5" cx="409.8" cy="423.4" r="8.9" />
        <circle class="st5" cx="409.3" cy="396" r="8.9" />
        <circle class="st5" cx="409.8" cy="637.4" r="8.9" />
        <circle class="st5" cx="409.3" cy="610" r="8.9" />
        <circle class="st5" cx="410.3" cy="584.3" r="8.9" />
        <circle class="st5" cx="409.8" cy="557.6" r="8.9" />
        <circle class="st5" cx="409.3" cy="530.1" r="8.9" />
        <circle class="st5" cx="701.9" cy="578.3" r="8.9" />
        <circle class="st5" cx="701.4" cy="550.9" r="8.9" />
        <circle class="st5" cx="702.4" cy="525.2" r="8.9" />
        <circle class="st5" cx="701.9" cy="498.5" r="8.9" />
        <circle class="st5" cx="701.4" cy="471" r="8.9" />
        <circle class="st5" cx="228.3" cy="397.9" r="8.9" />
        <circle class="st5" cx="227.8" cy="370.5" r="8.9" />
        <circle class="st5" cx="228.8" cy="344.8" r="8.9" />
        <circle class="st5" cx="228.3" cy="318.1" r="8.9" />
        <circle class="st5" cx="227.8" cy="290.6" r="8.9" />
        <circle class="st5" cx="782.4" cy="283" r="8.9" />
        <circle class="st5" cx="781.9" cy="256.3" r="8.9" />
        <circle class="st5" cx="781.4" cy="228.9" r="8.9" />
        <circle class="st5" cx="745.7" cy="401.5" r="8.9" />
        <circle class="st5" cx="745.2" cy="374.8" r="8.9" />
        <circle class="st5" cx="744.7" cy="347.4" r="8.9" />
        <circle class="st5" cx="782.1" cy="205.3" r="6.5" />
        <circle class="st5" cx="782.1" cy="181.3" r="6.5" />
        <circle class="st5" cx="745.2" cy="323.1" r="6.5" />
        <circle class="st5" cx="745.2" cy="299.1" r="6.5" />
        <circle class="st5" cx="745.2" cy="531.9" r="6.5" />
        <circle class="st5" cx="745.2" cy="507.9" r="6.5" />
        <circle class="st5" cx="780" cy="581.1" r="6.5" />
        <circle class="st5" cx="780" cy="557.1" r="6.5" />
        <circle class="st5" cx="780" cy="627.2" r="6.5" />
        <circle class="st5" cx="780" cy="603.1" r="6.5" />
        <circle class="st5" cx="895.7" cy="585.2" r="6.5" />
        <circle class="st5" cx="895.7" cy="561.2" r="6.5" />
        <circle class="st5" cx="895.7" cy="632.3" r="6.5" />
        <circle class="st5" cx="895.7" cy="608.3" r="6.5" />
        <circle class="st0" cx="994.8" cy="327.5" r="13.6" />
        <circle class="st0" cx="994.8" cy="267.8" r="13.6" />
        <circle class="st0" cx="995.1" cy="387" r="13.6" />
        <ellipse class="st0" cx="995.4" cy="537.3" rx="13.3" ry="14.2" />
        <circle class="st0" cx="965" cy="327.5" r="15.1" />
        <circle class="st13" cx="995.6" cy="626.4" r="14.2" />
        <circle class="st13" cx="965.3" cy="626.5" r="14.2" />
        <circle class="st12" cx="1026.4" cy="327.2" r="16.7" />
        <circle class="st12" cx="1026" cy="357.5" r="16.7" />
        <circle class="st12" cx="1025.7" cy="387.8" r="16.7" />
        <circle class="st12" cx="1025.2" cy="419.6" r="16.7" />
        <circle class="st11" cx="1133.7" cy="432" r="16.7" />
        <circle class="st11" cx="1134.5" cy="464.1" r="16.7" />
        <circle class="st11" cx="1166.9" cy="432" r="16.7" />
        <circle class="st1" cx="1167.7" cy="464.1" r="16.7" />
        <circle class="st11" cx="1134.7" cy="495.6" r="16.7" />
        <circle class="st11" cx="1167.4" cy="495.6" r="16.7" />
        <circle class="st1" cx="1167.7" cy="215.4" r="16.7" />
        <circle class="st1" cx="1167.7" cy="181.6" r="16.7" />
        <circle class="st1" cx="1167.7" cy="149.2" r="16.7" />
        <circle class="st11" cx="1167.4" cy="246.9" r="16.7" />
        <circle class="st1" cx="1135.3" cy="527.9" r="16.7" />
        <circle class="st11" cx="1133.7" cy="401.5" r="16.7" />
        <circle class="st11" cx="1133.7" cy="371.3" r="16.7" />
        <circle class="st11" cx="1133.7" cy="341.8" r="16.7" />
        <circle class="st11" cx="1166.9" cy="402.6" r="16.7" />
        <circle class="st11" cx="1199.2" cy="431.1" r="16.7" />
        <circle class="st1" cx="1200" cy="463.1" r="16.7" />
        <circle class="st11" cx="1199.7" cy="494.6" r="16.7" />
        <circle class="st11" cx="1199.2" cy="401.6" r="16.7" />
        <circle class="st11" cx="1166.9" cy="372" r="16.7" />
        <circle class="st11" cx="1166.9" cy="341.8" r="16.7" />
        <circle class="st11" cx="1166.9" cy="312.4" r="16.7" />
        <circle class="st11" cx="1167.5" cy="279.6" r="16.7" />
        <circle class="st1" cx="1200.9" cy="182.2" r="16.7" />
        <circle class="st1" cx="1200.9" cy="148.4" r="16.7" />
        <circle class="st1" cx="1200.9" cy="116" r="16.7" />
        <circle class="st11" cx="1200.7" cy="213.7" r="16.7" />
        <circle class="st11" cx="1200.7" cy="246.4" r="16.7" />
        <circle class="st1" cx="1233.2" cy="182.9" r="16.7" />
        <circle class="st1" cx="1233.2" cy="149.1" r="16.7" />
        <circle class="st1" cx="1233.2" cy="116.5" r="16.7" />
        <circle class="st1" cx="1233.2" cy="82.7" r="16.7" />
        <circle class="st11" cx="1232.9" cy="214.4" r="16.7" />
        <circle class="st11" cx="1233" cy="247.1" r="16.7" />
        <circle class="st11" cx="1199.2" cy="372" r="16.7" />
        <circle class="st11" cx="1199.2" cy="341.8" r="16.7" />
        <circle class="st11" cx="1199.2" cy="312.4" r="16.7" />
        <circle class="st11" cx="1232.4" cy="280.1" r="16.7" />
        <circle class="st11" cx="1199.8" cy="279.6" r="16.7" />
        <circle class="st11" cx="1133.7" cy="314.1" r="16.7" />
        <circle class="st12" cx="1026.6" cy="447.5" r="16.7" />
        <circle class="st12" cx="965.8" cy="358.6" r="16.7" />
        <circle class="st12" cx="965.6" cy="388.8" r="16.7" />
        <circle class="st12" cx="965.1" cy="420.6" r="16.7" />
        <circle class="st12" cx="964.5" cy="448.5" r="16.7" />
        <circle class="st12" cx="964.9" cy="477.9" r="16.7" />
        <circle class="st12" cx="995.6" cy="417.4" r="16.7" />
        <circle class="st12" cx="995" cy="445.4" r="16.7" />
        <circle class="st12" cx="995.4" cy="474.7" r="16.7" />
        <circle class="st12" cx="994.8" cy="506.5" r="16.7" />
        <circle class="st12" cx="1025.1" cy="566.6" r="16.7" />
        <circle class="st14" cx="964.7" cy="537.4" r="12.1" />
        <circle class="st14" cx="1025.5" cy="536.9" r="12.1" />
        <circle class="st14" cx="1055.6" cy="446.8" r="12.1" />
        <circle class="st1" cx="1137.5" cy="227.4" r="12.1" />
        <circle class="st10" cx="1263.5" cy="80.9" r="12.1" />
        <circle class="st1" cx="1232.9" cy="53.7" r="12.1" />
        <circle class="st1" cx="1139" cy="182.9" r="12.1" />
        <circle class="st8" cx="1134.5" cy="559.3" r="12.1" />
        <circle class="st8" cx="1180.2" cy="674.6" r="12.1" />
        <circle class="st8" cx="1134.5" cy="585.7" r="12.1" />
        <circle class="st10" cx="1134.5" cy="612.1" r="12.1" />
        <circle class="st10" cx="1134.5" cy="639.9" r="12.1" />
        <circle class="st14" cx="1055.4" cy="417.5" r="12.1" />
        <circle class="st14" cx="1054.8" cy="387.5" r="12.1" />
        <circle class="st14" cx="1054.7" cy="357.2" r="12.1" />
        <circle class="st14" cx="1025.5" cy="597.8" r="12.1" />
        <circle class="st14" cx="1025.6" cy="628" r="12.1" />
        <circle class="st15" cx="964.4" cy="509.2" r="14.5" />
        <circle class="st15" cx="1026.8" cy="508.4" r="14.5" />
        <circle class="st15" cx="1027" cy="478.5" r="14.5" />
        <circle class="st8" cx="1133.9" cy="283.1" r="14.5" />
        <circle class="st8" cx="1167.6" cy="527" r="14.5" />
        <circle class="st1" cx="1136.3" cy="254.3" r="14.5" />
        <circle class="st8" cx="1086.1" cy="675.1" r="14.5" />
        <circle class="st1" cx="1118" cy="675.1" r="14.5" />
        <circle class="st1" cx="1149.3" cy="674.1" r="14.5" />
        <circle class="st8" cx="1262.9" cy="43.6" r="14.5" />
        <circle class="st8" cx="1200.8" cy="84.8" r="14.5" />
        <circle class="st8" cx="1167.7" cy="118.5" r="14.5" />
        <circle class="st14" cx="965.9" cy="567.5" r="9.8" />
        <circle class="st2" cx="1054.2" cy="329" r="7.5" />
        <circle class="st10" cx="1137.9" cy="206.7" r="7.5" />
        <circle class="st10" cx="1261.1" cy="110.3" r="7.5" />
        <circle class="st10" cx="1260.7" cy="140.7" r="7.5" />
        <circle class="st10" cx="1151" cy="702.6" r="7.5" />
        <circle class="st10" cx="1118.2" cy="702.1" r="7.5" />
        <circle class="st10" cx="1200.7" cy="520.1" r="7.5" />
        <circle class="st2" cx="1057.5" cy="477" r="7.5" />
        <circle class="st2" cx="966.2" cy="597.2" r="7.5" />
        <circle class="st14" cx="994.3" cy="567.4" r="9.8" />
        <circle class="st14" cx="996" cy="297.6" r="9.8" />
        <circle class="st2" cx="994.6" cy="597.1" r="7.5" />
        <circle class="st2" cx="966.2" cy="656.3" r="7.5" />
        <circle class="st2" cx="994.6" cy="656.2" r="7.5" />
        <circle class="st2" cx="965.2" cy="297.9" r="4.3" />
        <circle class="st2" cx="1024.9" cy="297.3" r="4.3" />
        <circle class="st2" cx="1024.9" cy="266.5" r="4.3" />
        <circle class="st2" cx="966.1" cy="267" r="4.3" />
        <circle class="st16" cx="934.8" cy="682.5" r="8.9" />
        <circle class="st16" cx="934.3" cy="655.1" r="8.9" />
        <circle class="st5" cx="935" cy="625.9" r="8.9" />
        <circle class="st16" cx="1083.5" cy="440.9" r="8.9" />
        <circle class="st16" cx="1083" cy="413.4" r="8.9" />
        <circle class="st5" cx="1083.7" cy="384.3" r="8.9" />
        <circle class="st16" cx="1083.9" cy="356.5" r="8.9" />
        <circle class="st5" cx="1054.4" cy="300.6" r="8.9" />
        <circle class="st5" cx="1055.1" cy="245.9" r="6.5" />
        <circle class="st5" cx="1055.1" cy="221.8" r="6.5" />
        <circle class="st16" cx="1054.6" cy="272.9" r="8.9" />
        <circle class="st5" cx="1084.4" cy="300.2" r="6.5" />
        <circle class="st5" cx="1084.4" cy="276.2" r="6.5" />
        <circle class="st5" cx="1105.9" cy="312.9" r="6.5" />
        <circle class="st5" cx="1105.9" cy="282.8" r="6.5" />
        <circle class="st5" cx="1105.9" cy="370.7" r="6.5" />
        <circle class="st5" cx="1105.9" cy="399.8" r="6.5" />
        <circle class="st5" cx="1105.2" cy="430.6" r="6.5" />
        <circle class="st5" cx="1105.8" cy="462.9" r="6.5" />
        <circle class="st5" cx="1106" cy="498.7" r="6.5" />
        <circle class="st5" cx="1106" cy="529.8" r="6.5" />
        <circle class="st5" cx="1105.9" cy="339.9" r="6.5" />
        <circle class="st16" cx="1083.9" cy="327.2" r="8.9" />
        <circle class="st16" cx="1106.4" cy="204.4" r="8.9" />
        <circle class="st5" cx="1106.9" cy="156.9" r="6.5" />
        <circle class="st5" cx="1106.9" cy="132.8" r="6.5" />
        <circle class="st5" cx="1138" cy="156.1" r="6.5" />
        <circle class="st5" cx="1138" cy="132.1" r="6.5" />
        <circle class="st5" cx="1138" cy="108.2" r="6.5" />
        <circle class="st5" cx="1138" cy="84.1" r="6.5" />
        <circle class="st5" cx="1166.1" cy="90.7" r="6.5" />
        <circle class="st5" cx="1166.1" cy="66.8" r="6.5" />
        <circle class="st5" cx="1166.1" cy="42.8" r="6.5" />
        <circle class="st5" cx="1199.7" cy="55.5" r="6.5" />
        <circle class="st5" cx="1199.7" cy="31.4" r="6.5" />
        <circle class="st5" cx="1231.9" cy="30.7" r="6.5" />
        <circle class="st16" cx="1106.4" cy="180.5" r="8.9" />
        <circle class="st5" cx="746" cy="275.2" r="8.9" />
        <circle class="st16" cx="746.3" cy="247.5" r="8.9" />
        <circle class="st5" cx="746.8" cy="191.2" r="6.5" />
        <circle class="st5" cx="746.8" cy="167.2" r="6.5" />
        <circle class="st5" cx="705.7" cy="197.2" r="6.5" />
        <circle class="st5" cx="705.7" cy="173.2" r="6.5" />
        <circle class="st5" cx="705.7" cy="150.2" r="6.5" />
        <circle class="st5" cx="705.7" cy="126.1" r="6.5" />
        <circle class="st5" cx="666.8" cy="197.2" r="6.5" />
        <circle class="st5" cx="666.8" cy="173.2" r="6.5" />
        <circle class="st5" cx="666.8" cy="150.2" r="6.5" />
        <circle class="st5" cx="666.8" cy="126.1" r="6.5" />
        <circle class="st5" cx="631.7" cy="197.2" r="6.5" />
        <circle class="st5" cx="631.7" cy="173.2" r="6.5" />
        <circle class="st5" cx="631.7" cy="150.2" r="6.5" />
        <circle class="st5" cx="631.7" cy="126.1" r="6.5" />
        <circle class="st5" cx="631.7" cy="102.9" r="6.5" />
        <circle class="st5" cx="631.7" cy="79.9" r="6.5" />
        <circle class="st5" cx="595.8" cy="179.1" r="6.5" />
        <circle class="st5" cx="595.8" cy="156.1" r="6.5" />
        <circle class="st5" cx="595.8" cy="132.1" r="6.5" />
        <circle class="st5" cx="595.8" cy="108.9" r="6.5" />
        <circle class="st5" cx="595.8" cy="85.9" r="6.5" />
        <circle class="st5" cx="520.6" cy="138.1" r="6.5" />
        <circle class="st5" cx="520.6" cy="114.9" r="6.5" />
        <circle class="st5" cx="520.6" cy="91.9" r="6.5" />
        <circle class="st5" cx="483.5" cy="144.2" r="8.9" />
        <circle class="st5" cx="483" cy="116.7" r="8.9" />
        <circle class="st5" cx="483" cy="91.1" r="6.5" />
        <circle class="st5" cx="483" cy="67.8" r="6.5" />
        <circle class="st5" cx="409.1" cy="123.6" r="6.5" />
        <circle class="st5" cx="409.1" cy="100.4" r="6.5" />
        <circle class="st5" cx="334.7" cy="104.3" r="6.5" />
        <circle class="st5" cx="334.7" cy="81.1" r="6.5" />
        <circle class="st5" cx="335.2" cy="60" r="6.5" />
        <circle class="st5" cx="228.3" cy="265.1" r="6.5" />
        <circle class="st5" cx="228.3" cy="241.8" r="6.5" />
        <circle class="st5" cx="202.2" cy="265.1" r="6.5" />
        <circle class="st5" cx="202.2" cy="241.8" r="6.5" />
        <circle class="st5" cx="228.8" cy="220.7" r="6.5" />
        <circle class="st5" cx="226.7" cy="467.6" r="6.5" />
        <circle class="st5" cx="226.7" cy="444.3" r="6.5" />
        <circle class="st5" cx="227.2" cy="423.2" r="6.5" />
        <circle class="st5" cx="202.6" cy="397.9" r="8.9" />
        <circle class="st5" cx="202.1" cy="370.5" r="8.9" />
        <circle class="st5" cx="203.1" cy="344.8" r="8.9" />
        <circle class="st5" cx="202.6" cy="318.1" r="8.9" />
        <circle class="st5" cx="202.1" cy="290.6" r="8.9" />
        <circle class="st5" cx="201" cy="444.3" r="6.5" />
        <circle class="st5" cx="201.5" cy="423.2" r="6.5" />
        <circle class="st5" cx="299.6" cy="772.4" r="6.5" />
        <circle class="st5" cx="299.6" cy="749.2" r="6.5" />
        <circle class="st5" cx="300.1" cy="728.1" r="6.5" />
        <circle class="st5" cx="744.7" cy="600.7" r="6.5" />
        <circle class="st5" cx="744.7" cy="577.5" r="6.5" />
        <circle class="st5" cx="745.2" cy="556.4" r="6.5" />
        <circle class="st5" cx="779.6" cy="695.4" r="6.5" />
        <circle class="st5" cx="779.6" cy="672.2" r="6.5" />
        <circle class="st5" cx="780.1" cy="651.1" r="6.5" />
        <circle class="st5" cx="409.1" cy="705.7" r="6.5" />
        <circle class="st5" cx="409.1" cy="682.4" r="6.5" />
        <circle class="st5" cx="409.5" cy="661.3" r="6.5" />
        <circle class="st5" cx="372.7" cy="474.9" r="6.5" />
        <circle class="st5" cx="372.7" cy="451.6" r="6.5" />
        <circle class="st5" cx="373.1" cy="430.6" r="6.5" />
        <circle class="st5" cx="335.2" cy="36.7" r="6.5" />
        <circle class="st5" cx="444.5" cy="216.5" r="8.9" />
        <circle class="st5" cx="444.5" cy="190.9" r="6.5" />
        <circle class="st5" cx="444.5" cy="167.6" r="6.5" />
        <circle class="st5" cx="483" cy="44.8" r="6.5" />
        <circle class="st5" cx="631.7" cy="55.9" r="6.5" />
        <circle class="st16" cx="746.3" cy="218.2" r="8.9" />
        <circle class="st5" cx="1025.4" cy="217.6" r="6.5" />
        <circle class="st5" cx="1025.4" cy="193.6" r="6.5" />
        <circle class="st5" cx="994.4" cy="238.6" r="6.5" />
        <circle class="st5" cx="994.4" cy="214.5" r="6.5" />
        <circle class="st16" cx="1024.9" cy="244.6" r="8.9" />
        <circle class="st5" cx="966.4" cy="217.4" r="6.5" />
        <circle class="st5" cx="966.4" cy="193.4" r="6.5" />
        <circle class="st16" cx="966" cy="244.4" r="8.9" />
        <circle class="st5" cx="933.8" cy="281" r="6.5" />
        <circle class="st5" cx="933.8" cy="257" r="6.5" />
        <circle class="st5" cx="933.7" cy="564.1" r="6.5" />
        <circle class="st5" cx="933.7" cy="588.1" r="6.5" />
        <circle class="st16" cx="934.2" cy="537.1" r="8.9" />
        <circle class="st16" cx="934.2" cy="510.3" r="8.9" />
        <circle class="st5" cx="965.5" cy="735.8" r="6.5" />
        <circle class="st5" cx="965.5" cy="759.8" r="6.5" />
        <circle class="st5" cx="895.3" cy="655.4" r="6.5" />
        <circle class="st16" cx="966" cy="708.8" r="8.9" />
        <circle class="st16" cx="966" cy="682" r="8.9" />
        <circle class="st5" cx="1056.7" cy="559.2" r="6.5" />
        <circle class="st5" cx="1056.7" cy="583.3" r="6.5" />
        <circle class="st16" cx="1057.1" cy="532.2" r="8.9" />
        <circle class="st5" cx="1082.6" cy="500.3" r="6.5" />
        <circle class="st5" cx="1082.6" cy="531.8" r="6.5" />
        <circle class="st16" cx="1083.1" cy="472" r="8.9" />
        <circle class="st16" cx="1057.1" cy="505.4" r="8.9" />
        <circle class="st5" cx="1025.7" cy="710.7" r="6.5" />
        <circle class="st5" cx="1025.7" cy="734.7" r="6.5" />
        <circle class="st16" cx="1026.2" cy="683.7" r="8.9" />
        <circle class="st5" cx="1053.3" cy="656.3" r="6.5" />
        <circle class="st5" cx="1053.3" cy="680.3" r="6.5" />
        <circle class="st16" cx="1053.8" cy="629.3" r="8.9" />
        <circle class="st16" cx="1077.2" cy="629.3" r="8.9" />
        <circle class="st16" cx="1026.2" cy="656.9" r="8.9" />
        <circle class="st5" cx="994.8" cy="734.9" r="6.5" />
        <circle class="st5" cx="994.8" cy="759" r="6.5" />
        <circle class="st5" cx="910.8" cy="709.1" r="6.5" />
        <circle class="st5" cx="940" cy="708.2" r="6.5" />
        <circle class="st5" cx="910.8" cy="736.7" r="6.5" />
        <circle class="st5" cx="940" cy="735.8" r="6.5" />
        <circle class="st5" cx="1120.5" cy="727.5" r="6.5" />
        <circle class="st5" cx="1120.5" cy="751.5" r="6.5" />
        <circle class="st5" cx="1180.8" cy="726.4" r="6.5" />
        <circle class="st5" cx="1149.8" cy="726.6" r="6.5" />
        <circle class="st5" cx="1149.8" cy="750.7" r="6.5" />
        <circle class="st5" cx="1199.1" cy="638.6" r="6.5" />
        <circle class="st5" cx="1228.9" cy="612.3" r="6.5" />
        <circle class="st5" cx="1228.7" cy="638.2" r="6.5" />
        <circle class="st5" cx="1228.4" cy="669.8" r="6.5" />
        <circle class="st5" cx="1228.3" cy="699.2" r="6.5" />
        <circle class="st5" cx="1088.3" cy="720.8" r="6.5" />
        <circle class="st16" cx="995.2" cy="707.9" r="8.9" />
        <circle class="st16" cx="995.2" cy="681.1" r="8.9" />
        <circle class="st10" cx="705.3" cy="252" r="7.5" />
        <circle class="st10" cx="705.9" cy="223.8" r="7.5" />
        <circle class="st17" cx="675.7" cy="104.9" r="45.6" />
        <path
          class="st11"
          d="M602.5,32.2c-28,0-50.7,22.7-50.7,50.7c0,28,22.7,50.7,50.7,50.7s50.7-22.7,50.7-50.7
		C653.2,54.9,630.5,32.2,602.5,32.2z M602.5,118.7c-19.8,0-35.8-16-35.8-35.8s16-35.8,35.8-35.8c19.8,0,35.8,16,35.8,35.8
		S622.2,118.7,602.5,118.7z"
        />
        <path
          class="st11"
          d="M188.3,599c-28,0-50.7,22.7-50.7,50.7c0,28,22.7,50.7,50.7,50.7s50.7-22.7,50.7-50.7
		C239,621.7,216.3,599,188.3,599z M188.3,685.4c-19.8,0-35.8-16-35.8-35.8s16-35.8,35.8-35.8s35.8,16,35.8,35.8
		S208,685.4,188.3,685.4z"
        />
        <circle class="st2" cx="1289.7" cy="220.3" r="12.5" />
        <circle class="st2" cx="1289" cy="249.1" r="12.5" />
        <circle class="st14" cx="1318.2" cy="249.5" r="12.5" />
        <circle class="st0" cx="1288.3" cy="311.5" r="14.7" />
        <circle class="st0" cx="1440.9" cy="314.3" r="14.7" />
        <circle class="st4" cx="1620.6" cy="314.6" r="13.6" />
        <circle class="st4" cx="1620.6" cy="254.9" r="13.6" />
        <circle class="st4" cx="1620.9" cy="374.1" r="13.6" />
        <circle class="st0" cx="1470.3" cy="314.4" r="14.7" />
        <circle class="st0" cx="1471.6" cy="584.8" r="13" />
        <circle class="st0" cx="1441" cy="674.2" r="16.4" />
        <circle class="st0" cx="1470.9" cy="674.8" r="16.4" />
        <circle class="st0" cx="1501.2" cy="674.1" r="16.4" />
        <circle class="st0" cx="1501.8" cy="643.6" r="16.4" />
        <circle class="st0" cx="1500.9" cy="614.1" r="14" />
        <circle class="st0" cx="1441.8" cy="344.4" r="15.2" />
        <circle class="st0" cx="1471" cy="375.5" r="15.2" />
        <circle class="st0" cx="1441.2" cy="374.3" r="15.2" />
        <circle class="st0" cx="1410" cy="464.8" r="15.2" />
        <circle class="st0" cx="1349.4" cy="521.5" r="15.9" />
        <circle class="st0" cx="1348.7" cy="551.3" r="15.9" />
        <circle class="st0" cx="1348.8" cy="582.1" r="15.9" />
        <circle class="st0" cx="1289" cy="581.4" r="15.9" />
        <circle class="st0" cx="1258.1" cy="608.2" r="15.9" />
        <circle class="st0" cx="1318.6" cy="311.3" r="12.8" />
        <circle class="st0" cx="1288.5" cy="340.9" r="12.8" />
        <circle class="st0" cx="1288.7" cy="370.7" r="12.8" />
        <circle class="st0" cx="1349.7" cy="460.2" r="12.8" />
        <circle class="st0" cx="1378.2" cy="460.8" r="12.8" />
        <ellipse class="st4" cx="1621.2" cy="524.4" rx="13.3" ry="14.2" />
        <circle class="st0" cx="1411.6" cy="313.4" r="12.8" />
        <circle class="st4" cx="1590.8" cy="314.6" r="15.1" />
        <circle class="st0" cx="1289.5" cy="400.6" r="12.8" />
        <circle class="st0" cx="1288.6" cy="610.6" r="12.8" />
        <circle class="st0" cx="1379.8" cy="701.8" r="14.6" />
        <circle class="st0" cx="1317.5" cy="702.2" r="14.6" />
        <circle class="st0" cx="1318.3" cy="370.8" r="12.8" />
        <circle class="st0" cx="1318.3" cy="400.7" r="12.8" />
        <circle class="st14" cx="1288.1" cy="280.1" r="9.8" />
        <circle class="st14" cx="1410.7" cy="494.7" r="9.8" />
        <circle class="st14" cx="1471.2" cy="615.2" r="9.8" />
        <circle class="st14" cx="1441.3" cy="644.7" r="13.2" />
        <circle class="st14" cx="1258.3" cy="341.6" r="10.9" />
        <circle class="st14" cx="1258.2" cy="521.5" r="10.9" />
        <circle class="st14" cx="1319.7" cy="551.2" r="12.2" />
        <circle class="st14" cx="1257.7" cy="577" r="10.9" />
        <circle class="st14" cx="1289.1" cy="731.6" r="10.9" />
        <circle class="st14" cx="1228.3" cy="731.6" r="10.9" />
        <circle class="st13" cx="1258.8" cy="370.5" r="12.9" />
        <circle class="st13" cx="1258.8" cy="401.2" r="14" />
        <circle class="st13" cx="1378.5" cy="431.7" r="14" />
        <circle class="st13" cx="1258.6" cy="431.7" r="16.2" />
        <circle class="st13" cx="1350" cy="490.9" r="16.2" />
        <circle class="st13" cx="1257.9" cy="491.3" r="16.2" />
        <circle class="st13" cx="1289.1" cy="431.1" r="16.2" />
        <circle class="st13" cx="1317.7" cy="430.6" r="16.2" />
        <circle class="st13" cx="1440.7" cy="404.9" r="16.2" />
        <circle class="st13" cx="1469.3" cy="405.3" r="16.2" />
        <circle class="st6" cx="1621.5" cy="613.5" r="14.2" />
        <circle class="st6" cx="1591.1" cy="613.6" r="14.2" />
        <circle class="st13" cx="1440.5" cy="705.2" r="16.2" />
        <circle class="st13" cx="1411" cy="674.4" r="12.5" />
        <circle class="st13" cx="1501.4" cy="494.3" r="12.5" />
        <circle class="st12" cx="1349.2" cy="311.8" r="18" />
        <circle class="st12" cx="1501.7" cy="314.1" r="16.7" />
        <circle class="st6" cx="1652.2" cy="314.4" r="16.7" />
        <circle class="st6" cx="1651.8" cy="344.7" r="16.7" />
        <circle class="st6" cx="1651.5" cy="374.9" r="16.7" />
        <circle class="st6" cx="1651" cy="406.7" r="16.7" />
        <circle class="st6" cx="1652.4" cy="434.7" r="16.7" />
        <circle class="st6" cx="1591.6" cy="345.7" r="16.7" />
        <circle class="st6" cx="1591.4" cy="375.9" r="16.7" />
        <circle class="st6" cx="1590.9" cy="407.7" r="16.7" />
        <circle class="st6" cx="1590.3" cy="435.7" r="16.7" />
        <circle class="st6" cx="1590.7" cy="465" r="16.7" />
        <circle class="st6" cx="1621.4" cy="404.5" r="16.7" />
        <circle class="st6" cx="1620.8" cy="432.5" r="16.7" />
        <circle class="st6" cx="1621.3" cy="461.8" r="16.7" />
        <circle class="st6" cx="1620.6" cy="493.6" r="16.7" />
        <circle class="st6" cx="1650.9" cy="553.8" r="16.7" />
        <circle class="st12" cx="1502.2" cy="344.7" r="16.7" />
        <circle class="st12" cx="1502.5" cy="374.8" r="16.7" />
        <circle class="st12" cx="1501.2" cy="405.7" r="16.7" />
        <circle class="st12" cx="1501" cy="435" r="16.7" />
        <circle class="st12" cx="1501.7" cy="464.4" r="16.7" />
        <circle class="st12" cx="1410.9" cy="344.5" r="16.7" />
        <circle class="st12" cx="1410.4" cy="374.9" r="16.7" />
        <circle class="st12" cx="1411.2" cy="405.4" r="16.7" />
        <circle class="st12" cx="1410.9" cy="435" r="16.7" />
        <circle class="st12" cx="1440.4" cy="435" r="16.7" />
        <circle class="st12" cx="1440.4" cy="465.8" r="16.7" />
        <circle class="st12" cx="1440.4" cy="495.2" r="16.7" />
        <circle class="st12" cx="1440.2" cy="524.7" r="16.7" />
        <circle class="st12" cx="1440.4" cy="555.5" r="16.7" />
        <circle class="st12" cx="1471.1" cy="435" r="16.7" />
        <circle class="st12" cx="1471.1" cy="465.8" r="16.7" />
        <circle class="st12" cx="1471.1" cy="495.2" r="16.7" />
        <circle class="st12" cx="1471" cy="524.7" r="16.7" />
        <circle class="st12" cx="1471.2" cy="555.5" r="16.7" />
        <circle class="st12" cx="1440.9" cy="584.6" r="16.7" />
        <circle class="st12" cx="1440.9" cy="616" r="16.7" />
        <circle class="st12" cx="1349.2" cy="341.7" r="18" />
        <circle class="st12" cx="1379.6" cy="340.6" r="17.5" />
        <circle class="st12" cx="1379.5" cy="374" r="17.5" />
        <circle class="st12" cx="1379.6" cy="400.8" r="17.5" />
        <circle class="st12" cx="1348.4" cy="370.9" r="18" />
        <circle class="st12" cx="1349.9" cy="402.2" r="18" />
        <circle class="st12" cx="1351.3" cy="430.6" r="18" />
        <circle class="st12" cx="1258.4" cy="461.7" r="18" />
        <circle class="st12" cx="1289.6" cy="462" r="18" />
        <circle class="st12" cx="1289.9" cy="490.2" r="18" />
        <circle class="st12" cx="1288.2" cy="523" r="18" />
        <circle class="st12" cx="1318.5" cy="521.3" r="18" />
        <circle class="st12" cx="1288.4" cy="551.9" r="18" />
        <circle class="st12" cx="1348.5" cy="611.3" r="18" />
        <circle class="st12" cx="1349" cy="641.4" r="18" />
        <circle class="st12" cx="1348.4" cy="670.4" r="18.2" />
        <circle class="st12" cx="1348.4" cy="701.1" r="18.2" />
        <circle class="st12" cx="1259.4" cy="731.8" r="18.2" />
        <circle class="st12" cx="1258.4" cy="701.8" r="18.2" />
        <circle class="st12" cx="1258.6" cy="671.1" r="18.2" />
        <circle class="st12" cx="1259.2" cy="640.7" r="18.2" />
        <circle class="st12" cx="1319.9" cy="490.8" r="15.8" />
        <circle class="st12" cx="1319.2" cy="462.4" r="18" />
        <circle class="st14" cx="1318.3" cy="280.8" r="9.8" />
        <circle class="st14" cx="1440.7" cy="285" r="9.8" />
        <circle class="st14" cx="1471.4" cy="284.4" r="9.8" />
        <circle class="st14" cx="1531.6" cy="374.3" r="12.1" />
        <circle class="st14" cx="1531.6" cy="464" r="12.1" />
        <circle class="st4" cx="1590.5" cy="524.5" r="12.1" />
        <circle class="st18" cx="1651.3" cy="524" r="12.1" />
        <circle class="st18" cx="1681.4" cy="433.9" r="12.1" />
        <circle class="st18" cx="1681.2" cy="404.6" r="12.1" />
        <circle class="st18" cx="1680.6" cy="374.7" r="12.1" />
        <circle class="st18" cx="1680.5" cy="344.4" r="12.1" />
        <circle class="st18" cx="1651.3" cy="584.9" r="12.1" />
        <circle class="st18" cx="1651.4" cy="615.1" r="12.1" />
        <circle class="st15" cx="1532.3" cy="403" r="14.5" />
        <circle class="st15" cx="1532.9" cy="433.9" r="14.5" />
        <circle class="st4" cx="1590.2" cy="496.3" r="14.5" />
        <circle class="st4" cx="1652.6" cy="495.5" r="14.5" />
        <circle class="st4" cx="1652.8" cy="465.6" r="14.5" />
        <circle class="st14" cx="1531.5" cy="344.3" r="9.8" />
        <circle class="st14" cx="1501.6" cy="584.1" r="9.8" />
        <circle class="st18" cx="1591.7" cy="554.6" r="9.8" />
        <circle class="st2" cx="1319" cy="221" r="7.5" />
        <circle class="st2" cx="1441" cy="254.4" r="7.5" />
        <circle class="st2" cx="1470.6" cy="254.2" r="7.5" />
        <circle class="st2" cx="1500.8" cy="524.9" r="7.5" />
        <circle class="st2" cx="1501.3" cy="554.9" r="7.5" />
        <circle class="st19" cx="1680" cy="316.1" r="7.5" />
        <circle class="st19" cx="1683.4" cy="464.1" r="7.5" />
        <circle class="st19" cx="1561.5" cy="433.9" r="7.5" />
        <circle class="st19" cx="1561.3" cy="404.9" r="7.5" />
        <circle class="st19" cx="1592.1" cy="584.3" r="7.5" />
        <circle class="st18" cx="1620.1" cy="554.5" r="9.8" />
        <circle class="st18" cx="1621.8" cy="284.8" r="9.8" />
        <circle class="st19" cx="1620.4" cy="584.2" r="7.5" />
        <circle class="st19" cx="1592" cy="643.4" r="7.5" />
        <circle class="st19" cx="1620.4" cy="643.3" r="7.5" />
        <circle class="st2" cx="1378.3" cy="520.3" r="5.6" />
        <circle class="st2" cx="1378.1" cy="539.6" r="4.3" />
        <circle class="st19" cx="1561.2" cy="374.9" r="4.3" />
        <circle class="st19" cx="1561.4" cy="463.9" r="4.3" />
        <circle class="st19" cx="1591" cy="285" r="4.3" />
        <circle class="st19" cx="1650.7" cy="284.4" r="4.3" />
        <circle class="st19" cx="1650.7" cy="253.6" r="4.3" />
        <circle class="st19" cx="1591.9" cy="254.1" r="4.3" />
        <circle class="st2" cx="1379.1" cy="310.3" r="7.5" />
        <circle class="st16" cx="1441.3" cy="224.4" r="7.5" />
        <circle class="st16" cx="1348.4" cy="280.5" r="8.9" />
        <circle class="st16" cx="1261.3" cy="281.2" r="8.9" />
        <circle class="st16" cx="1261.2" cy="253.6" r="8.9" />
        <circle class="st16" cx="1347.9" cy="253.8" r="8.9" />
        <circle class="st16" cx="1347.4" cy="226.3" r="8.9" />
        <circle class="st16" cx="1378.7" cy="283.2" r="8.9" />
        <circle class="st16" cx="1378.2" cy="256.5" r="8.9" />
        <circle class="st16" cx="1377.7" cy="229" r="8.9" />
        <circle class="st5" cx="1378.4" cy="199.9" r="8.9" />
        <circle class="st16" cx="1410.8" cy="282.3" r="8.9" />
        <circle class="st16" cx="1410.3" cy="255.6" r="8.9" />
        <circle class="st16" cx="1409.8" cy="228.2" r="8.9" />
        <circle class="st5" cx="1410.5" cy="199.1" r="8.9" />
        <circle class="st20" cx="1501.7" cy="253.8" r="8.9" />
        <circle class="st20" cx="1501.2" cy="227.2" r="8.9" />
        <circle class="st16" cx="1500.7" cy="199.7" r="8.9" />
        <circle class="st5" cx="1501.3" cy="170.6" r="8.9" />
        <circle class="st16" cx="1471.9" cy="196.4" r="8.9" />
        <circle class="st16" cx="1471.4" cy="169.7" r="8.9" />
        <circle class="st16" cx="1470.9" cy="142.2" r="8.9" />
        <circle class="st5" cx="1471.6" cy="113.1" r="8.9" />
        <circle class="st16" cx="1440.6" cy="198.2" r="8.9" />
        <circle class="st16" cx="1440.1" cy="171.5" r="8.9" />
        <circle class="st16" cx="1439.6" cy="144" r="8.9" />
        <circle class="st5" cx="1440.3" cy="114.9" r="8.9" />
        <circle class="st16" cx="1529.9" cy="289" r="8.9" />
        <circle class="st16" cx="1529.4" cy="262.3" r="8.9" />
        <circle class="st16" cx="1528.9" cy="234.9" r="8.9" />
        <circle class="st5" cx="1529.6" cy="205.7" r="8.9" />
        <circle class="st16" cx="1560.6" cy="669.6" r="8.9" />
        <circle class="st21" cx="1533" cy="674.3" r="11.2" />
        <circle class="st21" cx="1381.4" cy="673.1" r="11.2" />
        <circle class="st16" cx="1560.1" cy="642.2" r="8.9" />
        <circle class="st16" cx="1533" cy="642.8" r="8.9" />
        <circle class="st16" cx="1532" cy="614.1" r="8.9" />
        <circle class="st16" cx="1532" cy="584.9" r="8.9" />
        <circle class="st5" cx="1560.8" cy="613" r="8.9" />
        <circle class="st16" cx="1502.9" cy="765" r="8.9" />
        <circle class="st16" cx="1502.4" cy="737.6" r="8.9" />
        <circle class="st5" cx="1503.1" cy="708.4" r="8.9" />
        <circle class="st16" cx="1472.8" cy="764.2" r="8.9" />
        <circle class="st16" cx="1472.3" cy="736.7" r="8.9" />
        <circle class="st5" cx="1473" cy="707.6" r="8.9" />
        <circle class="st5" cx="1377.9" cy="173.2" r="8.9" />
        <circle class="st5" cx="1377.4" cy="145.8" r="8.9" />
        <circle class="st5" cx="1232.1" cy="308.6" r="8.9" />
        <circle class="st5" cx="1289.1" cy="191.8" r="8.9" />
        <circle class="st5" cx="1288.6" cy="165.1" r="8.9" />
        <circle class="st5" cx="1288.1" cy="137.7" r="8.9" />
        <circle class="st5" cx="1261.8" cy="197.3" r="6.5" />
        <circle class="st5" cx="1261.8" cy="173.2" r="6.5" />
        <circle class="st5" cx="1378.3" cy="585.7" r="6.5" />
        <circle class="st5" cx="1378.3" cy="561.6" r="6.5" />
        <circle class="st5" cx="1378.3" cy="635" r="6.5" />
        <circle class="st5" cx="1378.3" cy="611" r="6.5" />
        <circle class="st5" cx="1349.1" cy="779.3" r="6.5" />
        <circle class="st5" cx="1349.1" cy="755.2" r="6.5" />
        <circle class="st5" cx="1319.5" cy="196.1" r="8.9" />
        <circle class="st5" cx="1319" cy="169.4" r="8.9" />
        <circle class="st5" cx="1318.5" cy="141.9" r="8.9" />
        <circle class="st22" cx="1232.4" cy="394.8" r="8.9" />
        <circle class="st22" cx="1231.9" cy="368.1" r="8.9" />
        <circle class="st5" cx="1232.4" cy="536.4" r="8.9" />
        <circle class="st5" cx="1231.9" cy="509.7" r="8.9" />
        <circle class="st5" cx="1230.4" cy="589.1" r="8.9" />
        <circle class="st5" cx="1231.3" cy="562.4" r="8.9" />
        <circle class="st22" cx="1231.4" cy="340.7" r="8.9" />
        <circle class="st22" cx="1233" cy="477.6" r="8.9" />
        <circle class="st22" cx="1232.4" cy="450.9" r="8.9" />
        <circle class="st22" cx="1232" cy="423.5" r="8.9" />
        <circle class="st16" cx="1261.4" cy="224.3" r="8.9" />
        <circle class="st5" cx="1530.3" cy="151" r="6.5" />
        <circle class="st5" cx="1530.3" cy="127" r="6.5" />
        <circle class="st16" cx="1529.9" cy="178" r="8.9" />
        <circle class="st16" cx="1709.3" cy="428" r="8.9" />
        <circle class="st16" cx="1708.8" cy="400.5" r="8.9" />
        <circle class="st5" cx="1709.5" cy="371.4" r="8.9" />
        <circle class="st16" cx="1709.7" cy="343.6" r="8.9" />
        <circle class="st5" cx="1680.2" cy="287.7" r="8.9" />
        <circle class="st5" cx="1680.9" cy="233" r="6.5" />
        <circle class="st5" cx="1680.9" cy="208.9" r="6.5" />
        <circle class="st16" cx="1680.4" cy="260" r="8.9" />
        <circle class="st5" cx="1710.2" cy="287.4" r="6.5" />
        <circle class="st5" cx="1710.2" cy="263.3" r="6.5" />
        <circle class="st16" cx="1709.7" cy="314.4" r="8.9" />
        <circle class="st5" cx="1651.2" cy="204.8" r="6.5" />
        <circle class="st5" cx="1651.2" cy="180.7" r="6.5" />
        <circle class="st5" cx="1620.2" cy="225.7" r="6.5" />
        <circle class="st5" cx="1620.2" cy="201.6" r="6.5" />
        <circle class="st16" cx="1650.7" cy="231.8" r="8.9" />
        <circle class="st16" cx="1411" cy="705.6" r="8.9" />
        <circle class="st16" cx="1409.3" cy="652.7" r="8.9" />
        <circle class="st5" cx="1410" cy="623.6" r="8.9" />
        <circle class="st16" cx="1410.2" cy="595.8" r="8.9" />
        <circle class="st5" cx="1592.2" cy="204.5" r="6.5" />
        <circle class="st5" cx="1592.2" cy="180.5" r="6.5" />
        <circle class="st16" cx="1591.8" cy="231.5" r="8.9" />
        <circle class="st5" cx="1559.6" cy="268.1" r="6.5" />
        <circle class="st5" cx="1559.6" cy="244.1" r="6.5" />
        <circle class="st16" cx="1559.1" cy="295.1" r="8.9" />
        <circle class="st16" cx="1559.1" cy="321.9" r="8.9" />
        <circle class="st5" cx="1559.5" cy="551.2" r="6.5" />
        <circle class="st5" cx="1559.5" cy="575.2" r="6.5" />
        <circle class="st5" cx="1531.7" cy="521.8" r="6.5" />
        <circle class="st5" cx="1531.7" cy="545.9" r="6.5" />
        <circle class="st16" cx="1560" cy="524.2" r="8.9" />
        <circle class="st16" cx="1560" cy="497.4" r="8.9" />
        <circle class="st5" cx="1591.3" cy="722.9" r="6.5" />
        <circle class="st5" cx="1591.3" cy="746.9" r="6.5" />
        <circle class="st16" cx="1591.8" cy="695.9" r="8.9" />
        <circle class="st16" cx="1591.8" cy="669.1" r="8.9" />
        <circle class="st5" cx="1682.5" cy="546.3" r="6.5" />
        <circle class="st5" cx="1682.5" cy="570.4" r="6.5" />
        <circle class="st16" cx="1683" cy="519.3" r="8.9" />
        <circle class="st5" cx="1708.4" cy="486.1" r="6.5" />
        <circle class="st5" cx="1708.4" cy="510.1" r="6.5" />
        <circle class="st16" cx="1708.9" cy="459.1" r="8.9" />
        <circle class="st16" cx="1683" cy="492.6" r="8.9" />
        <circle class="st5" cx="1651.5" cy="697.8" r="6.5" />
        <circle class="st5" cx="1651.5" cy="721.8" r="6.5" />
        <circle class="st16" cx="1652" cy="670.8" r="8.9" />
        <circle class="st5" cx="1679.1" cy="643.4" r="6.5" />
        <circle class="st5" cx="1679.1" cy="667.4" r="6.5" />
        <circle class="st16" cx="1679.6" cy="616.4" r="8.9" />
        <circle class="st16" cx="1703" cy="616.4" r="8.9" />
        <circle class="st16" cx="1652" cy="644" r="8.9" />
        <circle class="st5" cx="1620.6" cy="722" r="6.5" />
        <circle class="st5" cx="1620.6" cy="746.1" r="6.5" />
        <circle class="st16" cx="1621" cy="695" r="8.9" />
        <circle class="st16" cx="1621" cy="668.3" r="8.9" />
        <circle class="st16" cx="1559.3" cy="346.3" r="8.9" />
        <circle class="st16" cx="1319.5" cy="787.3" r="8.9" />
        <circle class="st16" cx="1319.7" cy="757.9" r="8.9" />
        <circle class="st16" cx="1288.7" cy="791" r="8.9" />
        <circle class="st16" cx="1288.9" cy="761.6" r="8.9" />
        <circle class="st16" cx="1289.1" cy="817.9" r="8.9" />
        <circle class="st16" cx="1258.8" cy="796" r="8.9" />
        <circle class="st16" cx="1259" cy="766.6" r="8.9" />
        <circle class="st16" cx="1316.3" cy="670.5" r="8.9" />
        <circle class="st16" cx="1316.4" cy="641.1" r="8.9" />
        <circle class="st16" cx="1472.4" cy="224.3" r="7.5" />
        <circle class="st20" cx="1502" cy="282.7" r="7.5" />
        <circle class="st16" cx="1530.8" cy="314.3" r="7.5" />
        <circle class="st16" cx="1532.6" cy="496.1" r="7.5" />
        <circle class="st16" cx="1410.4" cy="546.6" r="7.5" />
        <circle class="st16" cx="1410.2" cy="568.5" r="7.5" />
        <circle class="st2" cx="1378.9" cy="490.8" r="7.5" />
        <circle class="st2" cx="1410.5" cy="520.9" r="7.5" />
        <circle class="st2" cx="1470.7" cy="643.4" r="7.5" />
        <circle class="st2" cx="1288.2" cy="670.3" r="7.5" />
        <circle class="st16" cx="1317.6" cy="610.2" r="6.4" />
        <circle class="st2" cx="1318.7" cy="581.2" r="7.5" />
        <circle class="st2" cx="1319.1" cy="730.8" r="8.7" />
        <circle class="st2" cx="1348.8" cy="731.6" r="8.7" />
        <circle class="st2" cx="1259.4" cy="551.3" r="7.5" />
        <circle class="st2" cx="1288.6" cy="693.3" r="7.5" />
        <circle class="st2" cx="1258.6" cy="311" r="7.5" />
        <circle class="st2" cx="1289.1" cy="641.8" r="10.9" />
        <path
          class="st23"
          d="M1374.6,96.3c-28,0-50.7,22.7-50.7,50.7c0,28,22.7,50.7,50.7,50.7c28,0,50.7-22.7,50.7-50.7
		C1425.3,119,1402.6,96.3,1374.6,96.3z M1374.6,182.8c-19.8,0-35.8-16-35.8-35.8s16-35.8,35.8-35.8s35.8,16,35.8,35.8
		S1394.3,182.8,1374.6,182.8z"
        />
        <path
          class="st6"
          d="M1725.4,138.5c-19.9,0-36.1,16.2-36.1,36.1c0,19.9,16.2,36.1,36.1,36.1c19.9,0,36.1-16.2,36.1-36.1
		C1761.5,154.7,1745.3,138.5,1725.4,138.5z M1725.4,200.1c-14.1,0-25.5-11.4-25.5-25.5s11.4-25.5,25.5-25.5
		c14.1,0,25.5,11.4,25.5,25.5S1739.5,200.1,1725.4,200.1z"
        />
        <circle class="st24" cx="1319.8" cy="122.1" r="45.6" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.st0 {
  fill: #ff5b85;
}
.st1 {
  fill: #00b649;
}
.st2 {
  fill: #fca5b7;
}
.st3 {
  fill: #0084e1;
}
.st4 {
  fill: #fdb667;
}
.st5 {
  fill: #f2e9ed;
}
.st6 {
  fill: #ffa318;
}
.st7 {
  fill: #006aba;
}
.st8 {
  fill: #00eb7d;
}
.st9 {
  fill: #00a9ff;
}
.st10 {
  fill: #95e9ba;
}
.st11 {
  fill: #178659;
}
.st12 {
  fill: #f23100;
}
.st13 {
  fill: #ff3240;
}
.st14 {
  fill: #ff7193;
}
.st15 {
  fill: #ee6c8f;
}
.st16 {
  fill: #f2e2ea;
}
.st17 {
  fill: #e597c0;
}
.st18 {
  fill: #f6cfaa;
}
.st19 {
  fill: #f8dbc4;
}
.st20 {
  fill: #fbb3c6;
}
.st21 {
  fill: #f6adc1;
}
.st22 {
  fill: #fa98b1;
}
.st23 {
  fill: #e42906;
}
.st24 {
  fill: #0770d3;
}

.heartbeat {
  animation: pulse 1s infinite;
  transform-origin: center; /* Säkerställ att skalningen sker från mitten av cirkeln */
  transform-box: fill-box;
}

#Heart_blue,
#Heart_pink_5 {
  animation: pulse1 1s infinite;
}
#Heart_yellow {
  animation: pulse2 1s infinite;
}
#Heart_green_1 {
  animation: pulse3 1s infinite;
}
#Heart_pink_1 {
  animation: pulse4 1s infinite;
}
#Heart_pink_2 {
  animation: pulse5 1s infinite;
}
#Heart_pink_3 {
  animation: pulse6 1s infinite;
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  30% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse1 {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  15% {
    /* Example change */
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse2 {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  25% {
    /* Example change */
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse3 {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  35% {
    /* Example change */
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse4 {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  45% {
    /* Example change */
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse5 {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  55% {
    /* Example change */
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse6 {
  0%,
  100% {
    transform: scale(0.7);
    opacity: 0.6;
  }
  75% {
    /* Example change */
    transform: scale(1);
    opacity: 1;
  }
}

.svg-container {
  width: 80%;

  @media (max-width: 1199px) {
    width: 90%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Svg/People.vue